import { ApplicationConfig, inject, isDevMode, provideAppInitializer, Type } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { UserService } from '../services/user.service';
import { OFFICE_CONTEXT } from './office.config';
import { initializeOfficeMock } from './office.mock';

export function bootstrapOutlookAddin(component: Type<unknown>, config: ApplicationConfig): void {
  window.history.replaceState ??= () => {};
  window.history.pushState ??= () => {};
  resolveOfficeContext()
    .then(async context => {
      if (!context) return showOfficeConnectionError();
      await bootstrapApplication(component, {
        ...config,
        providers: [
          ...config.providers,
          { provide: OFFICE_CONTEXT, useValue: context },
          provideAppInitializer(() => inject(UserService).ready),
        ],
      });
    })
    .catch(error => console.error(error));
}

async function resolveOfficeContext(): Promise<Office.Context | null> {
  const office = (globalThis as { Office?: typeof Office }).Office;
  if (typeof office?.onReady === 'function') {
    try {
      const info = await office.onReady();
      const context = office.context;
      if (info.host === office.HostType?.Outlook && typeof context?.mailbox?.item?.body?.getAsync === 'function')
        return context;
    } catch (error: unknown) {
      console.error(error);
    }
  }
  return isDevMode() ? initializeOfficeMock() : null;
}

function showOfficeConnectionError(): void {
  const message = document.createElement('div');
  message.setAttribute('role', 'alert');
  message.textContent = 'Unable to connect to Microsoft Office. Open this add-in in Outlook.';
  document.body.replaceChildren(message);
}
